import { useState } from "react";

import { EditIcon } from "@dotnet/telematics-design-system";

import { ApiCredential, INTEGRATIONS_ACTIONS } from "../../../../../shared";

const useIntegrationsApiInlineActions = () => {
  const [rowData, setRowData] = useState<ApiCredential | null>(null);
  const [isEditOpen, setIsEditOpen] = useState<boolean>(false);

  const handleEditApiCredential = async (currentRowData: ApiCredential) => {
    setRowData(currentRowData);
    setIsEditOpen(true);
  };

  const closeEditDialog = () => {
    setRowData(null);
    setIsEditOpen(false);
  };

  const inlineActions = [
    {
      title: INTEGRATIONS_ACTIONS.EditIntegration,
      icon: <EditIcon />,
      clickAction: handleEditApiCredential,
      renderConditions: () => true
    }
  ];

  return {
    inlineActions,
    rowData,
    isEditOpen,
    setRowData,
    closeEditDialog
  };
};

export default useIntegrationsApiInlineActions;
